import { Fragment, useEffect, useState } from "react";
import { withRouter, Switch, Route } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import _ from "lodash";
import moment from "moment-timezone";
import { Grid } from '@mui/material';
import { fetchServiceLines } from "../../actions/Users/authenticate";
import { getLastThreeMonth } from "../../constants/Constants";
import UserGuideDoc from '../../asset/user_guide/Starlink_Cloud_User_Guide.pdf';
import { fetchUserListAPI, parentDpAndSubDpList, updatePermission, updateSideMenu } from "../../actions/Users/authenticate";
import { SIDE_MENU_ITEM_STARLINK, not_authorized_page_title, not_authorized_page_message, commonParams, STARLINK_TOS_VALIDATED, not_authorized_page_message_orbit } from "../../utils/constants";
import { getDecodeURI, getEncodedURI, populateForParent, updateTimePeriod, PERIOD_OPTIONS, isAuthorizedFor, STARLINK_FEATURES, useAuthorization } from "../../utils/util";
import { setDpIds, setServiceAccount } from "./slice";
import { validateTosAcceptance, fetchStarlinkTosValidation } from "../../components/StarlinkToS/slice";
import { ACTION_TYPES } from "../../components/StarlinkReports/slice";
import CommonFilters from "../../components/BreadCrumbs/CommonFilters";
import TabsComponent from "../../components/NewTabs";
import NotAuthorized from "../NotAuthorized";
import { StarlinkNavTabs } from './types';
import StarlinkReports from "../../components/StarlinkReports";
import ServiceAccounts from "../../components/StarlinkAdmin/ServiceAccounts";
import ServiceLines from "../../components/StarlinkAdmin/ServiceLines";
import UserTerminals from "../../components/StarlinkAdmin/UserTerminals";
import AuditLogs from "../../components/StarlinkAdmin/AuditLogs";
import StarlinkAnalytics from "../../components/StarlinkAnalytics";
import StarlinkQuota from "../../components/StarlinkQuota";
import MapLeaflet from "../../components/ServiceLines";
import StarlinkPlans from "../../components/StarlinkPlans";
import StarlinkReportsPlanUsage from "../../components/StarlinkReportsPlanUsage";
import "./index.css";
import StarlinkDashboard from "../../components/StarlinkDashboard";

const periodOptions = PERIOD_OPTIONS.default;
const periodOptionsPlans = PERIOD_OPTIONS.plans;
const periodOptionsUsage = PERIOD_OPTIONS.usage;
const periodOptionsDash = PERIOD_OPTIONS.dashboard;

function Starlink(props) {
    const { authReducer, errorReducer, match, location, history, starlinkReports, errorInTosValidationState, fetchStarlinkTosValidation, validateTosLoading, serviceAccounts, fetchServiceLines, tosAccepted, starlinkAnalytics, starlinkQuota, starlinkDashboard, dpIds, starlinkAdmin, validateTosAcceptance, parentDpAndSubDpList, updatePermission, updateSideMenu, setDpIds, setServiceAccount, fetchUserListAPI, starlinkPooled, gettingAssets, gettingAssetsCSV, gettingAssetUsage, gettingAssetCurrentBillingCcleUsage, settingQuotaAlert, gettingServiceLinesDashboard, gettingServiceAccounts, creatingServiceAccount, syncingServiceAccount, updatingServiceAccount, deletingServiceAccount, gettingServiceLinesAdmin, updatingServiceLine, gettingUserTerminalsAdmin, subcribingServiceLine, removingUserTerminal, gettingMetricSeries, gettingUserTerminalsAnalytics, gettingServiceLineQuotas, creatingQuota, deletingQuota, updatingQuota, gettingPooledUsagePie, gettingPooledBarChart, gettingPooledTopCards, gettingPooledlineChart, gettingPooledTable, gettingPooledUsagePieSplit, gettingStarlinkUsagePoolPlansChart, gettingStarlinkUsagePoolServiceLinesChart, gettingStarlinkUsageTopWidget, gettingStarlinkPlanUsageHierarchy, gettingPlanServiceLines, gettingAssetsPlanUsage, authLoading, userPreferencesLoading, addingTopup
 } = props;
    const { isAdmin, isFull, canViewAdmin } = useAuthorization();
    const [loading, setLoading] = useState(false);
    const [isTosAccepted, setIsTosAccepted] = useState<boolean>(tosAccepted);
    const [stepperValue, setStepperValue] = useState(0)
    const [activeTab, setActiveTab] = useState<StarlinkNavTabs>(match?.params?.tab ? match.params.tab : "starlinkMap");
    const [authorizedToViewTos, setAuthorizedToViewTos] =  useState<boolean>(false);
    const [isAuthorizedToViewPage, setIsAuthorizedToViewPage] = useState<boolean>(false);
    const [errorInTosValidation, setErrorInTosValidation] = useState(false)
    const dispatch = useDispatch();
    const [billPortAccess, setBillPortAccess] = useState(false);

    useEffect(()=>{
        const tosValidated = JSON.parse(localStorage.getItem("STARLINK_TOS_VALIDATED") || "null")
        const tosValue = tosValidated?.find((item) => item.dpId === authReducer?.selectedOu?.id)?.tos;
        setIsTosAccepted(tosValue) 
    },[JSON.parse(localStorage.getItem("STARLINK_TOS_VALIDATED") || "null")])

    useEffect(() => {
       
        if ((authReducer && !authReducer.sideMenu) || (SIDE_MENU_ITEM_STARLINK !== authReducer.sideMenu.menuItem)) {
            updateSideMenu({ menuItem: SIDE_MENU_ITEM_STARLINK });
        }
        if(authReducer?.selectedOu?.id){
        fetchServiceLines(authReducer?.selectedOu?.id)
        }
        return () => {
            // clear component data, no slice available for this component as of now
            // child component level clearing is handled already for existing components
        }
    }, [])

    useEffect(() => {
        if (match?.params?.tab) {
            setActiveTab(match.params.tab);
        }
    }, [match?.params?.tab]);

    useEffect(() => {
        let authorized;
        
        if (activeTab === "admin") {
            const authorized = isAuthorizedFor("admin") || isAuthorizedFor("full");
            setIsAuthorizedToViewPage(authorized);
        } else {
             const authorized = isAuthorizedFor("user") || isAuthorizedFor("full");
            setIsAuthorizedToViewPage(authorized);   
        }
     if (isAdmin || isFull) {
            if (authReducer && authReducer.selectedOu) {
                const info = {
                    permission: {
                          service: STARLINK_FEATURES.admin.service,
                        serviceFunction: STARLINK_FEATURES.admin.function,
                    },
                    isMultiVessel: false,
                    isSingleVessel: false,
                    showOu: true,
                    ou: authReducer?.selectedOu?.name || "",
                };
                updatePermission(info);
            }
            if (authReducer?.selectedOu?.name) {
                fetchUserListAPI(authReducer.selectedOu.name, 1, 1000000, '');
            }
        }
    }, [activeTab, authReducer.selectedOu])


    useEffect(() => {
    const selectedId = authReducer?.selectedOu?.id;
    let tosValidated = JSON.parse(localStorage.getItem(STARLINK_TOS_VALIDATED) || "null");

        const prevDetectedDP = tosValidated?.some((item) => item.dpId === selectedId);
        if (!localStorage.getItem(STARLINK_TOS_VALIDATED) || !prevDetectedDP) {
            if (selectedId) {
                // validateTosAcceptance({ dpId: selectedId });
                fetchStarlinkTosValidation(selectedId)
            }
        }

    const authorizedToViewTos = isAuthorizedFor("admin");

    if (authorizedToViewTos) {
        setAuthorizedToViewTos(authorizedToViewTos);
    }

}, [authReducer.selectedOu]);


    useEffect(()=>{
        if(stepperValue === 3){
            if (authReducer?.selectedOu?.id ) {
                // validateTosAcceptance({dpId:authReducer?.selectedOu?.id})
                 fetchStarlinkTosValidation(authReducer?.selectedOu?.id)
            }
        }
    },[stepperValue])

    const getChildren = (dpIds, dps) => {
        for (let i = 0; i < dps?.length; i++) {
            let id = dps[i]?.id;
            dpIds.push(id);
            if (dps[i].hasOwnProperty('_childern') && dps[i]['_childern']?.length > 0) {
                getChildren(dpIds, dps[i]['_childern'])
            }
        }
    }

    const getDPTree = (ous: any[], arr) => {
        if (ous && Array.isArray(ous)) {
            for (let i = 0; i < ous?.length; i++) {
                const item = ous[i];
                if (arr.hasOwnProperty(item.id)) {
                    const temp: any = arr[item.id];
                    arr[item.id] = { ...temp, ...item._childern };
                } else {
                    arr[item.id] = item._childern;
                }
                getDPTree(item._childern, arr);
            }
        }
    }

    const getDpList = (dpList) => {
        const tempArr: any = {};
        for (let i = 0; i < dpList.length; i++) {
            const _organisations = [];
            populateForParent(dpList[i], null, _organisations);
            getDPTree(_organisations, tempArr);
        }
        parentDpAndSubDpList(tempArr);
    }

    useEffect(() => { 
        let params: any = getDecodeURI(location?.search);
        delete params.starlinkTab;
        const { startDate, endDate } = updateTimePeriod(dispatch, location);
        params.startDate = startDate;
        params.endDate = endDate;
        history.push({ pathname: location.url, search: `?${getEncodedURI(params)}` });
    }, [])

    useEffect(() => {
        if (!_.isEmpty(authReducer.getOrganisationUnitList)) {
            if (authReducer.getOrganisationUnitList.dps && authReducer.getOrganisationUnitList.dps.length > 0) {
                getDpList(authReducer.getOrganisationUnitList.dps)
            }
        }
    }, [authReducer.getOrganisationUnitList])

    useEffect(() => {
        if (!_.isEmpty(authReducer.selectedOu)){
            // getServiceAccounts({
            //     dpIds,
            //     searchText: "",
            //    sortBy:"client_id",
            //    sortOrder:"desc",
            //    limit:10,
            //    page: 1
            // });
        }
        if (!_.isEmpty(authReducer.selectedOu) && authReducer.selectedOu.hasOwnProperty("id") && authReducer.selectedOu.id && authReducer.selectedOu.hasOwnProperty("name") && authReducer.selectedOu.name && !_.isEmpty(authReducer.parentDpAndSubDpList)) {
            const parentDpId = authReducer?.selectedOu?.id;
            const dpIds = authReducer?.parentDpAndSubDpList;
            if (dpIds.hasOwnProperty(parentDpId)) {
                const _dpIds: any = [];
                _dpIds.push(parentDpId);
                getChildren(_dpIds, dpIds[parentDpId]);
                return setDpIds(_dpIds.filter(id => id !== ""));
            }
        }
        return setDpIds([]);
    }, [authReducer.selectedOu, authReducer.parentDpAndSubDpList])

    const handleChangeActiveTab = (event: React.SyntheticEvent, newValue: StarlinkNavTabs) => {
        let pathName = `${event}`;
        if(pathName.includes("v2")) {
            localStorage.setItem("isStarV2", "true");
        } else {
            localStorage.setItem("isStarV2", "false");
        }
        const currentParams = getDecodeURI(location?.search);
        const params:any = {};
        const filterParams = (requiredKeys: string[]) => {
            requiredKeys.forEach(key => {
                if (Object.prototype.hasOwnProperty.call(currentParams, key)) {
                    params[key] = currentParams[key];
                }
            })
        }
        switch (newValue) {
            case "dashboard":
            case "starlinkMap":
            case "usage":
            case "plans":
            case "service_account":
            case "user_terminal":
            case "service_line":
                filterParams(commonParams);
            break;
            case "audit_logs":
                filterParams(commonParams);
                break;
            case "pooled":
                filterParams(['startDate', 'endDate', 'interval', 'size', 'search', 'ouName', 'ouId', 'sideNav', 'selectedAccount']);
                break;
            case "quota":
                filterParams(['startDate', 'endDate', 'interval', 'size', 'search', 'ouName', 'ouId', 'sideNav', 'serviceLineAccess']);
                break;
            case "analytics":
                filterParams(['startDate', 'endDate', 'interval', 'size', 'search', 'ouName', 'ouId', 'sideNav', 'serviceLineAccess']);
                break;
            case "admin":
                filterParams(['startDate', 'endDate', 'interval', 'ouName', 'ouId', 'sideNav', 'serviceLineAccess', 'selectedAccount']);
                break;
            case "plan_usage":
                filterParams(['ouName', 'ouId', 'sideNav', 'startDate', 'endDate', 'interval', 'serviceLineAccess', 'selectedAccount']);
                break;
            default:
                break;
        }
        const { startDate, endDate } = updateTimePeriod(dispatch, location);
        if(getLastThreeMonth().includes(params.interval)){
            params.interval = "MTD"
             params.startDate = moment().startOf('month').valueOf();
              params.endDate = moment().valueOf();
        }else{
            params.startDate = startDate;
            params.endDate = endDate;
        }
       
        history.replace({ pathname: `${event}`, search: getEncodedURI(params) })
        setActiveTab(newValue);

        if(newValue == 'plan_usage') {
            dispatch({type: ACTION_TYPES.GET_STARLINK_PLAN_USAGE_HIERARCHY, payload: {}})
        }
    };

    const helpAction = () => {
        window.open(UserGuideDoc)
    }

    useEffect(() => {
        setLoading(
            starlinkReports.gettingAssets ||
            starlinkReports.gettingAssetsCSV ||
            starlinkReports.gettingAssetUsage ||
            starlinkReports.gettingAssetCurrentBillingCcleUsage ||
            starlinkReports.settingQuotaAlert ||
            starlinkDashboard.gettingServiceLines ||
            starlinkAdmin.gettingServiceAccounts ||
            starlinkAdmin.gettingV2ServiceAccounts ||
            starlinkAdmin.creatingServiceAccount ||
            starlinkAdmin.syncingServiceAccount || 
            starlinkAdmin.updatingServiceAccount ||
            starlinkAdmin.deletingServiceAccount ||
            starlinkAdmin.gettingServiceLines ||
            starlinkAdmin.updatingServiceLine ||
            starlinkAdmin.gettingUserTerminals ||
            starlinkAdmin.subcribingServiceLine ||
            starlinkAnalytics.gettingMetricSeries > 0 ||
            starlinkAnalytics.gettingUserTerminals ||
            starlinkQuota.gettingServiceLineQuotas ||
            starlinkQuota.creating ||
            starlinkQuota.deleting ||
            starlinkQuota.updating ||
            authReducer.loading ||
            starlinkPooled.gettingPooledUsagePie ||
            starlinkPooled.gettingPooledBarChart ||
            starlinkPooled.gettingPooledTopCards ||
            starlinkPooled.gettingPooledlineChart ||
            starlinkPooled.gettingPooledTable ||
            starlinkPooled.gettingPooledUsagePieSplit ||
            starlinkReports.gettingStarlinkUsagePoolPlansChart ||
            starlinkReports.gettingStarlinkUsagePoolServiceLinesChart ||
            starlinkReports.gettingStarlinkUsageTopWidget ||
            starlinkReports.gettingStarlinkPlanUsageHierarchy ||
            starlinkReports.gettingPlanServiceLines ||
            starlinkReports.gettingAssetsPlanUsage ||
            starlinkAdmin.removingUserTerminal
        )
    }, [starlinkReports.gettingAssets, starlinkReports.gettingAssetsCSV, starlinkReports.gettingAssetUsage, starlinkReports.gettingAssetCurrentBillingCcleUsage, starlinkDashboard.gettingServiceLines, starlinkAdmin.gettingServiceAccounts, authReducer.loading, starlinkReports.settingQuotaAlert, starlinkAdmin.creatingServiceAccount, starlinkAdmin.updatingServiceAccount, starlinkAdmin.deletingServiceAccount, starlinkAdmin.gettingServiceLines, starlinkAdmin.updatingServiceLine, starlinkAdmin.gettingUserTerminals, starlinkAdmin.subcribingServiceLine, starlinkAnalytics.gettingMetricSeries, starlinkAnalytics.gettingUserTerminals, starlinkQuota.gettingServiceLineQuotas, starlinkQuota.creating, starlinkQuota.deleting, starlinkQuota.updating,
        starlinkPooled.gettingPooledUsagePie, starlinkPooled.gettingPooledBarChart, starlinkPooled.gettingPooledTopCards, starlinkPooled.gettingPooledlineChart, starlinkPooled.gettingPooledTable, starlinkPooled.gettingPooledUsagePieSplit, starlinkReports.gettingStarlinkUsagePoolPlansChart, starlinkReports.gettingStarlinkUsagePoolServiceLinesChart, starlinkReports.gettingStarlinkUsageTopWidget, starlinkReports.gettingStarlinkPlanUsageHierarchy, starlinkReports.gettingPlanServiceLines, starlinkReports.gettingAssetsPlanUsage, starlinkAdmin.removingUserTerminal, starlinkAdmin.syncingServiceAccount
    ])
    
     useEffect(() => {
        if (isAdmin) {
            localStorage.setItem("isAccountsEnabled", "true");
        }
    }, [isAdmin])

    useEffect(()=>{
        setErrorInTosValidation(errorInTosValidationState)
    },[errorInTosValidationState])

    const goToStarlinkDashborad = (value) =>{
        setStepperValue(value)
    }

    useEffect(() => {
        try {
            const services = JSON.parse(localStorage.getItem("permissions") || "[]");
            const hasBillPortAccess = services?.some(
                (service: any) =>
                    service?.service === "billport" &&
                    Array.isArray(service?.servicefunctions) &&
                    service?.servicefunctions?.length > 0
            );
            setBillPortAccess(hasBillPortAccess);
        } catch (error) {
            setBillPortAccess(false);
        }
    }, []);

    const tabs = [
        { tabName: 'Dashboard', tabValue: 'starlinkMap', pathName: '/starlink/starlinkMap' },
        { tabName: 'Usage', tabValue: 'usage', pathName: '/starlink/usage' },
        { tabName: 'Plans', tabValue: 'plans', pathName: '/starlink/plans', hideTab : isAdmin || isFull  ? "No" : "Yes"  },
        { tabName: 'Plan Usage', tabValue: 'plan_usage', pathName: '/starlink/plan_usage',  hideTab : isAdmin || isFull  ? "No" : "Yes"  },
        { tabName: 'Quota', tabValue: 'quota', pathName: '/starlink/quota', hideTab : isAdmin || isFull  ? "No" : "Yes" },
        { tabName: 'Insights', tabValue: 'analytics', pathName: '/starlink/analytics', },
        { tabName: 'Service Account', tabValue: 'service_account', pathName: '/starlink/service_account', hideTab : isAdmin || isFull  ? "No" : "Yes"  },
        { tabName: 'Service Line', tabValue: 'service_line', pathName: '/starlink/service_line', hideTab : isAdmin || isFull   ? "No" : "Yes"  },
        { tabName: 'User Terminals', tabValue: 'user_terminal', pathName: '/starlink/user_terminal', hideTab : isAdmin || isFull    ? "No" : "Yes"  },
        { tabName: 'Audit Logs', tabValue: 'audit_logs', pathName: '/starlink/audit_logs', hideTab : isAdmin || isFull   ? "No" : "Yes"  },
        { tabName: 'Bill Port', tabValue: 'bill_port', pathName: '/starlink/bill_port', hideTab :  billPortAccess ? "No" : "Yes"  },
    ]
    
    useEffect(() => {
        setServiceAccount(serviceAccounts && serviceAccounts.length > 0 && serviceAccounts[0] && serviceAccounts[0]?.serviceAccounts)
    }, [serviceAccounts])

    return (
        <Grid className="starlink--container">
            <CommonFilters 
            disableOu={stepperValue > 1 && (!isTosAccepted || stepperValue === 2 )} 
            isMultiVessel={true}
            loading={gettingAssets || gettingAssetsCSV || gettingAssetUsage || gettingAssetCurrentBillingCcleUsage || settingQuotaAlert || gettingServiceLinesDashboard || gettingServiceAccounts || creatingServiceAccount || syncingServiceAccount || updatingServiceAccount || deletingServiceAccount || gettingServiceLinesAdmin || updatingServiceLine || gettingUserTerminalsAdmin || subcribingServiceLine || removingUserTerminal || gettingMetricSeries || gettingUserTerminalsAnalytics || gettingServiceLineQuotas || creatingQuota || deletingQuota || updatingQuota || gettingPooledUsagePie || gettingPooledBarChart || gettingPooledTopCards || gettingPooledlineChart || gettingPooledTable || gettingPooledUsagePieSplit || gettingStarlinkUsagePoolPlansChart || gettingStarlinkUsagePoolServiceLinesChart || gettingStarlinkUsageTopWidget || gettingStarlinkPlanUsageHierarchy || gettingPlanServiceLines || gettingAssetsPlanUsage || authLoading || userPreferencesLoading || addingTopup
                        || authReducer?.userPreferencesLoading || starlinkAdmin?.addingTopup} 
            showSummaryPeriod={ ( activeTab === "usage"|| activeTab === "analytics" || activeTab == 'pooled')} 
            periodOptions={ activeTab === "usage" ? periodOptionsUsage : activeTab == 'starlinkMap' ? periodOptionsDash :  activeTab === "pooled" ? periodOptionsPlans : periodOptions} 
            showLastThreeMonths = { activeTab === "usage" }
            showPlans = { activeTab === "pooled" }
            showWantType={false} 
            helpIcon={false} helpAction={helpAction} 
            userGuide={[true, 'starlink-cloud']}
            minDateProp = {activeTab === 'analytics' ? moment().subtract(30, "days") : null}
            showSLDropDown={activeTab != 'plans' && activeTab != 'plan_usage' && activeTab != 'service_account'}
            showAllServiceLines={location.pathname?.includes("/starlink/service_line") }
            showAccounts={ (activeTab === "starlinkMap" || activeTab === "usage" || location.pathname?.includes("/starlink/service_line") || location.pathname?.includes("/starlink/user_terminal"))}
            >
            </CommonFilters>
            {
                !isTosAccepted || stepperValue === 2
                    ?
                    <NotAuthorized pageTitle={not_authorized_page_title} PageMessage={not_authorized_page_message_orbit} />
                    :
                    <>
                     <TabsComponent tabs={tabs} handleChangeTab={handleChangeActiveTab} activeTab={activeTab} />
                        {
                            isAuthorizedToViewPage ? <Fragment>
                                <Grid className={activeTab == 'admin' ? "starlink--tab_panel--container starlink-page-container" : "starlink--tab_panel--container"} id={activeTab == 'plan_usage' ? 'new-design-top-filters' : ''}>
                                    <Switch>
                                        <Route path="/starlink/dashboard" component={StarlinkDashboard} />
                                        <Route path="/starlink/usage" component={StarlinkReports} />
                                        <Route path="/starlink/plan_usage" component={StarlinkReportsPlanUsage} />
                                        {/* <Route path="/starlink/pooled" component={StarlinkPooled} /> */}
                                        <Route path="/starlink/quota" component={StarlinkQuota} />
                                        <Route path="/starlink/analytics" component={StarlinkAnalytics} />
                                        <Route path="/starlink/starlinkMap" component={MapLeaflet} />
                                        <Route path="/starlink/starlinkMapv2" component={MapLeaflet} />
                                        <Route path="/starlink/plans" component={StarlinkPlans} />
                                        <Route path="/starlink/service_account" component={ServiceAccounts} />
                                        <Route path="/starlink/service_line" component={ServiceLines}  />
                                        <Route path="/starlink/user_terminal" component={UserTerminals} />
                                        <Route path="/starlink/audit_logs" component={AuditLogs} />
                                    </Switch>
                                </Grid>
                            </Fragment>
                                : <NotAuthorized pageTitle={not_authorized_page_title} PageMessage={not_authorized_page_message} />
                        }
                    </>
            }
        </Grid>
    );
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
  errorReducer: state.errorReducer,
  starlinkReports: state.starlinkReports,
  starlinkDashboard: state.starlinkDashboard,
  starlinkAdmin: state.starlinkAdmin,
  tosAccepted: state?.starlinkToS?.tosAccepted,
  errorInTosValidationState: state?.starlinkToS.errorInTosValidation,
  validateTosLoading: state?.starlinkToS.validateTosLoading,
  starlinkAnalytics: state.starlinkAnalytics,
  starlinkQuota: state.starlinkQuota,
  dpIds: state.starlinkCloud.dpIds,
  serviceAccounts: state.starlinkAdmin.serviceAccounts,
  starlinkPooled: state.starlinkPooled,
  authLoading: state.authReducer.loading,
  userPreferencesLoading: state.authReducer.userPreferencesLoading,
  gettingAssets: state.starlinkReports.gettingAssets,
  gettingAssetsCSV: state.starlinkReports.gettingAssetsCSV,
  gettingAssetUsage: state.starlinkReports.gettingAssetUsage,
  gettingAssetCurrentBillingCcleUsage: state.starlinkReports.gettingAssetCurrentBillingCcleUsage,
  settingQuotaAlert: state.starlinkReports.settingQuotaAlert,
  gettingStarlinkUsagePoolPlansChart: state.starlinkReports.gettingStarlinkUsagePoolPlansChart,
  gettingStarlinkUsagePoolServiceLinesChart: state.starlinkReports.gettingStarlinkUsagePoolServiceLinesChart,
  gettingStarlinkUsageTopWidget: state.starlinkReports.gettingStarlinkUsageTopWidget,
  gettingStarlinkPlanUsageHierarchy: state.starlinkReports.gettingStarlinkPlanUsageHierarchy,
  gettingPlanServiceLines: state.starlinkReports.gettingPlanServiceLines,
  gettingAssetsPlanUsage: state.starlinkReports.gettingAssetsPlanUsage,
  gettingServiceLinesDashboard: state.starlinkDashboard.gettingServiceLines,
  gettingServiceAccounts: state.starlinkAdmin.gettingServiceAccounts,
  creatingServiceAccount: state.starlinkAdmin.creatingServiceAccount,
  syncingServiceAccount: state.starlinkAdmin.syncingServiceAccount,
  updatingServiceAccount: state.starlinkAdmin.updatingServiceAccount,
  deletingServiceAccount: state.starlinkAdmin.deletingServiceAccount,
  gettingServiceLinesAdmin: state.starlinkAdmin.gettingServiceLines,
  updatingServiceLine: state.starlinkAdmin.updatingServiceLine,
  gettingUserTerminalsAdmin: state.starlinkAdmin.gettingUserTerminals,
  subcribingServiceLine: state.starlinkAdmin.subcribingServiceLine,
  removingUserTerminal: state.starlinkAdmin.removingUserTerminal,
  addingTopup: state.starlinkAdmin.addingTopup,
  gettingMetricSeries: state.starlinkAnalytics.gettingMetricSeries,
  gettingUserTerminalsAnalytics: state.starlinkAnalytics.gettingUserTerminals,
  gettingServiceLineQuotas: state.starlinkQuota.gettingServiceLineQuotas,
  creatingQuota: state.starlinkQuota.creating,
  deletingQuota: state.starlinkQuota.deleting,
  updatingQuota: state.starlinkQuota.updating,
  gettingPooledUsagePie: state.starlinkPooled.gettingPooledUsagePie,
  gettingPooledBarChart: state.starlinkPooled.gettingPooledBarChart,
  gettingPooledTopCards: state.starlinkPooled.gettingPooledTopCards,
  gettingPooledlineChart: state.starlinkPooled.gettingPooledlineChart,
  gettingPooledTable: state.starlinkPooled.gettingPooledTable,
  gettingPooledUsagePieSplit: state.starlinkPooled.gettingPooledUsagePieSplit,
});


export default withRouter(
    connect(mapStateToProps, {
        parentDpAndSubDpList,
        updatePermission,
        updateSideMenu,
        setDpIds,
        fetchUserListAPI,
        validateTosAcceptance,
        setServiceAccount,
        fetchServiceLines,
        fetchStarlinkTosValidation
    })(Starlink)
);